module.exports = __webpack_public_path__ + "img/flight-note.0c806390.svg";